export const page_builder_origin = process.env.REACT_APP_PG_BUILDER_ENDPOINT;

// Keys used by the page-builder <-> creator-tool rating-setting bridge.
export const page_builder_rating_setting_payload_keys = {
  request_id: "requestId",
  feature_key: "featureKey",
  value: "value",
  ok: "ok",
};
